module.exports = __webpack_public_path__ + "static/media/addDisposalGroup.1e9b49ab.svg";